<template>
  <v-container fluid grid-list-md text-xs-center class="pt-0">
    <v-card class="pa-2 grey lighten-4 mb-3 card-r pb-2 shadow-1">
      <v-toolbar class="primary mb-3 card-r pl-3 text-white">
        <v-btn icon class="ma-0 primary text-white card-r no-shadow" to="/policemans"> <v-icon>arrow_left</v-icon></v-btn>
        <div class="text-xs-left f-20">Edit Police Details</div>
      </v-toolbar>
      <v-layout row wrap class="">
        <v-flex d-flex xs12 lg4 class=" ">
          <v-text-field solo
            placeholder="station name" class="pa-0 ma-0" label="Police Station name" v-model="name"></v-text-field>
        </v-flex>
        <v-flex d-flex xs12 lg4 class=" ">
          <v-text-field solo
            placeholder="55555557"
            prefix="+45"
            class="pa-0 ma-0" label="Phone" v-model="phone"></v-text-field>
        </v-flex>
        <v-flex d-flex xs12 lg4 class=" ">
          <v-text-field solo
            placeholder="enter mail" :rules="emailRules" class="pa-0 ma-0"  label="Email" v-model="email"> </v-text-field>
        </v-flex>

        <v-flex d-flex xs12 lg6 class=" ">
          <v-text-field solo
            placeholder="enter address"   class="pa-0 ma-0" label="Address" v-model="address"></v-text-field>
        </v-flex>

        <v-flex xs12 class="right">
          <v-btn @click="policeEdit()" depressed class="shadow-1 right card-r ma-0" color="primary">Update station</v-btn>
        </v-flex>
        <v-flex xs12 class="pt-0 pb-0 ">
          <v-alert
            v-if="alert.type=='success'"
            :value="true"
            color="success"
            icon="check_circle"
            outline
          >
            {{alert.msg}}
          </v-alert>
          <v-alert
            v-if="alert.type=='warning'"
            :value="true"
            color="error"
            icon="warning"
            outline
          >
            {{alert.msg}}
          </v-alert>
          <v-progress-circular
            indeterminate
            color="primary"
            v-if="loading"
          ></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>
<script>
  /* eslint-disable */
  import { mapState, dispatch } from "vuex";
  import api from '../../utils/backend-api.js'
  export default {
      name: "EditPolice",
    data: () => ({
       id:'',
       name:'',
       email:'',
       phone:'',
       address:'',

      // description:'',
      requiredRule: [v => !!v || "This field is required"],
      loading:false,
      alert:{
        type:'',
        msg:''
      },
      emailRules: [
				v => !!v || "E-mail is required",
				v =>
					/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
					"E-mail must be valid"
      ],
    }),
    mounted() {
      this.policeId = this.$route.params.id;
        Store.dispatch("police/getPoliceById", this.policeId).then(res => {
      });
      let policeData=this.$store.state.police.polices
      console.log(policeData)
      let singlePolice
      policeData.forEach(element=>{
        if(element.id==this.policeId){
          singlePolice=element
          console.log(element)
        }
      })

      setTimeout(() => {
          this.id=singlePolice.id
          this.name =singlePolice.name;
          this.email =singlePolice.email;
          this.phone =singlePolice.phone;
          this.address =singlePolice.address;
      }, 2000);
  },
    methods: {
      policeEdit(){
        this.loading=true
        var policeDetails={
            'name':this.name,
            'email':this.email,
            'phone':this.phone,
            'address':this.address,
        }
        var formData = new FormData();
          formData.append("name", this.name);
          formData.append("email", this.email);
          formData.append("phone", this.phone);
          formData.append("address", this.address);
        var policeId=this.policeId
        var Data={
          "policeDetails":formData,
          "policeId":this.id
        }

          // this.$store.commit('setLoading', { loading: true })
          api.postData('driver/updatePoliceStation/' + Data.policeId, Data.policeDetails).then(res => {
            console.log(res)
            if(res.status==201){
              this.loading=false
              this.alert.type='success'
              this.alert.msg='You have successfully updated'
              setTimeout(() => {
                  window.location.href = "/policemans"
              }, 1200);
            }
            this.$store.dispatch('police/setPolicesData',res.data)
          }).catch((error) => {
              this.loading=false
              this.alert.type='warning'
              this.alert.msg='Updation Failed.Check your details and try again'
          })
          // this.$store.dispatch('Modules/classEdit',Data).then(res=>{
          //   console.log(res)
          //   this.$store.commit('setLoading', { loading: false })

          // })
      },


    },
    components: {
      //ConfirmEdit,
      //Treeselect
    },
      computed: {
    ...mapState({
      polices: Polices => Store.state.police.polices
    })
  },
  };
</script>



// WEBPACK FOOTER //
// src/pages/pages/EditPoliceman.vue